/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.0.1
 * @since 1.0.0
 */

import React, { memo } from 'react';

import Highlighter from 'react-highlight-words';

import { KeyboardKeyCodeEnum } from '../../../app/appConstants';
import { ISuperSearchTranslation } from '../../../internationalization/types/corporate';
import { ISuperSearchAccounts } from '../../superSearchTypes';
import { declOfNum } from '../../superSearchUtils';
import {
    SuperSearchListGroupStyled,
    SuperSearchListGroupTitleStyled,
    SuperSearchListItem,
    SuperSearchListItemSecondary,
    SuperSearchListItemTitle,
} from '../styled/SuperSearchListStyled';


/**
 * @description Super search item account props
 * @interface ISuperSearchItemAccountsProps
 * @property {ISuperSearchAccounts[]} accounts - accounts list
 * @property {string} searchValue - search value
 * @property {(payload: ISetFilterPayload) => void} selectItem - select callback
 * @property {ICommonTranslation} translation - current locale
 */
export interface ISuperSearchItemAccountsProps {
    accounts: ISuperSearchAccounts[];
    searchValue: string;
    selectItem: (value: string) => void;
    translation: ISuperSearchTranslation;
}

const SuperSearchItemAccounts = (props: ISuperSearchItemAccountsProps) => {
    const selectHandler = (item: ISuperSearchAccounts) => {
        props.selectItem(item.id);
    };
    const keyDownHandler = (event: React.KeyboardEvent, item: ISuperSearchAccounts) => {
        if (event.keyCode === KeyboardKeyCodeEnum.ENTER ) {
            selectHandler(item);
        }
    };
    return (
        <SuperSearchListGroupStyled>
            <SuperSearchListGroupTitleStyled>
                {props.translation.accounts}
            </SuperSearchListGroupTitleStyled>
            {
                props.accounts.map((item: ISuperSearchAccounts) => (
                    <SuperSearchListItem
                        key={item.id + item.number}
                        onClick={() => selectHandler(item)}
                        onKeyDown={(e: React.KeyboardEvent) => keyDownHandler(e, item)}
                    >
                        <SuperSearchListItemTitle>
                            <Highlighter
                                autoEscape={true}
                                highlightClassName="super-search__item-text_bold"
                                searchWords={props.searchValue.split(' ')}
                                textToHighlight={item.number}
                            />
                        </SuperSearchListItemTitle>
                        <SuperSearchListItemSecondary>
                            <Highlighter
                                autoEscape={true}
                                highlightClassName="super-search__item-text_bold"
                                searchWords={props.searchValue.split(' ')}
                                textToHighlight={
                                    item.subsCount + ' ' + declOfNum(item.subsCount, props.translation.mobilesCount)
                                }
                            />,&nbsp;
                            <Highlighter
                                autoEscape={true}
                                highlightClassName="super-search__item-text_bold"
                                searchWords={props.searchValue.split(' ')}
                                textToHighlight={item.regionName}
                            />
                        </SuperSearchListItemSecondary>
                    </SuperSearchListItem>
                ))
            }
        </SuperSearchListGroupStyled>
    );
};

export default memo(SuperSearchItemAccounts);
